import React from "react";
import {FunctionComponent, useEffect, useState} from "react";

export interface VerticalDividerProps {
    height?: number | string;
    color?: string;
    borderRadius?: number;
    width?: number;
    margin?: string;
}

export const VerticalDivider: FunctionComponent<VerticalDividerProps> = ({
                                                                             height = 'parent',
                                                                             color = '#eee',
                                                                             borderRadius = 0,
                                                                             width = 1,
                                                                             margin = '0'
                                                                         }) => {
    const [dividerHeight, setDividerHeight] = useState<string | undefined>();

    useEffect(() => {
        if (height === 'parent') {
            setDividerHeight(undefined);
        } else if (typeof height === 'number') {
            setDividerHeight(`${height}px`);
        } else if (typeof height === 'string') {
            setDividerHeight(height);
        }
    }, [height]);

    const dividerStyle: React.CSSProperties = {
        height: dividerHeight,
        backgroundColor: color,
        borderRadius,
        width,
        alignSelf: 'stretch',
        margin
    };

    return <div style={dividerStyle}></div>;
};
